<div class="branch-promo__content" [ngClass]="{ 'branch-promo__content--header': header }">
  <ng-content></ng-content>
</div>
